import axiosInstance from "./AxiosInstance"

const API_URL = "/rankings"

export const getBatchRanking = async (batchId, page = 1, limit = 10, startDate = null, endDate = null) => {
  const params = { page, limit }
  if (startDate) params.startDate = startDate
  if (endDate) params.endDate = endDate

  const response = await axiosInstance.get(`${API_URL}/batches/${batchId}`, { params })
  return {
    data: response.data.data,
    pagination: response.data.pagination,
  }
}

